import { createGlobalStyle, DefaultTheme } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Roboto+Mono&display=swap');
  
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  html {
    font-size: 16px;
    scroll-behavior: smooth;
    
    @media (max-width: 768px) {
      font-size: 15px;
    }
    
    @media (max-width: 480px) {
      font-size: 14px;
    }
  }
  
  body {
    font-family: ${({ theme }) => theme.fonts.main};
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
    overflow-x: hidden;
    line-height: 1.6;
  }
  
  /* Effet de flashlight qui suit le curseur */
  body::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: radial-gradient(
      circle at var(--cursor-x, 50%) var(--cursor-y, 50%),
      rgba(255, 255, 255, 0.1) 0%,
      transparent 20%
    );
    z-index: 1;
    
    @media (max-width: 768px) {
      display: none; /* Disable flashlight effect on mobile */
    }
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: ${({ theme }) => theme.space.md};
  }
  
  h1 {
    font-size: ${({ theme }) => theme.fontSizes['5xl']};
    
    @media (max-width: 768px) {
      font-size: ${({ theme }) => theme.fontSizes['4xl']};
    }
    
    @media (max-width: 480px) {
      font-size: ${({ theme }) => theme.fontSizes['3xl']};
    }
  }
  
  h2 {
    font-size: ${({ theme }) => theme.fontSizes['4xl']};
    
    @media (max-width: 768px) {
      font-size: ${({ theme }) => theme.fontSizes['3xl']};
    }
    
    @media (max-width: 480px) {
      font-size: ${({ theme }) => theme.fontSizes['2xl']};
    }
  }
  
  h3 {
    font-size: ${({ theme }) => theme.fontSizes['3xl']};
    
    @media (max-width: 768px) {
      font-size: ${({ theme }) => theme.fontSizes['2xl']};
    }
    
    @media (max-width: 480px) {
      font-size: ${({ theme }) => theme.fontSizes.xl};
    }
  }
  
  h4 {
    font-size: ${({ theme }) => theme.fontSizes['2xl']};
    
    @media (max-width: 768px) {
      font-size: ${({ theme }) => theme.fontSizes.xl};
    }
  }
  
  h5 {
    font-size: ${({ theme }) => theme.fontSizes.xl};
    
    @media (max-width: 768px) {
      font-size: ${({ theme }) => theme.fontSizes.lg};
    }
  }
  
  h6 {
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
  
  p {
    margin-bottom: ${({ theme }) => theme.space.md};
  }
  
  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    transition: color ${({ theme }) => theme.transitions.normal} ease;
    
    &:hover {
      color: ${({ theme }) => theme.colors.accent};
    }
  }
  
  button {
    font-family: ${({ theme }) => theme.fonts.main};
    cursor: pointer;
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  code {
    font-family: ${({ theme }) => theme.fonts.monospace};
    background-color: ${({ theme }) => theme.colors.backgroundLight};
    padding: ${({ theme }) => theme.space.xs} ${({ theme }) => theme.space.sm};
    border-radius: ${({ theme }) => theme.borderRadius.sm};
  }

  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.backgroundLight};
  }
  
  ::-webkit-scrollbar-thumb {
    background: #444;
    border-radius: 4px;
    
    &:hover {
      background: #555;
    }
  }

  /* Sélection de texte */
  ::selection {
    background-color: ${({ theme }) => theme.colors.primary}40;
    color: ${({ theme }) => theme.colors.text};
  }
  
  /* Classes utilitaires */
  .container {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 ${({ theme }) => theme.space.md};
    
    @media (max-width: 768px) {
      padding: 0 ${({ theme }) => theme.space.sm};
    }
  }
  
  /* Mobile-specific styles */
  @media (max-width: 768px) {
    .hide-on-mobile {
      display: none !important;
    }
    
    .mobile-full-width {
      width: 100% !important;
      max-width: 100% !important;
      padding-left: 1rem !important;
      padding-right: 1rem !important;
    }
    
    /* Adjust standard padding for mobile views */
    section, div[class*="Container"], div[class*="Section"] {
      padding-left: 1rem !important;
      padding-right: 1rem !important;
    }
  }
`;

export default GlobalStyles;